import MyVisits from './MyVisits';

export default MyVisits;
